import type { ReactNode } from 'react';
import { Icon } from '@/lib/ui-kit/icons';
import { SidebarLink } from './SidebarLink';

interface CardHeaderProps {
  /** The caption, plus anything that sits right after it (the board switch). */
  title: ReactNode;
  /** Locale-less target of the chevron. */
  href: string;
  /** Accessible name of the chevron link. */
  linkLabel: string;
}

/** A card's caption on the left and a chevron to its full page on the right. */
export function CardHeader({ title, href, linkLabel }: CardHeaderProps) {
  return (
    <div className="relative flex items-center justify-between gap-2">
      <div className="flex min-w-0 items-center gap-1 text-[12px] leading-[1.15] text-v2-text-secondary">
        {title}
      </div>
      <SidebarLink
        href={href}
        aria-label={linkLabel}
        className="flex shrink-0 rounded-[4px] text-v2-text-secondary outline-none transition-colors duration-150 hover:text-v2-text-primary focus-visible:ring-2 focus-visible:ring-v2-bg-blue-50"
      >
        <Icon name="ArrowSmallDown" size={16} className="-rotate-90" />
      </SidebarLink>
    </div>
  );
}
